module.exports = __webpack_public_path__ + "img/guide.01.02.ea755dd9.jpg";